import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import numeral from 'numeral';
import Iconify from '../../../../Iconify';
import useRealNode from '../../../../../hooks/useRealNode';
import { ModalPanel, Bar, CloseButton, Content } from './modal-styled';
import { publish, subscribe, unsubscribe } from '../../../../../utils/events';
import billete from '../../../../../assets/images/cash1-50.png';

const EVENT_NAME = 'CONEKTA_PAYMENTS:SHOW_MODAL_SUCCESS';

// Flag global para rastrear si el modal ya está siendo mostrado
let isModalOpen = false;

export const showModalSuccessPayment = ({ amount, balance, trans_id }) => {
  return new Promise(resolve => {
    publish(EVENT_NAME, {
      resolve,
      transaction: {
        amount,
        balance,
        trans_id,
      },
    });
  });
};

export const ModalSuccess = () => {
  const node = useRealNode('modal-node-portal');
  const [isOpen, setIsOpen] = useState(false);
  const [transaction, setTransaction] = useState(null);
  const isThisInstanceOpenRef = React.useRef(false);

  useEffect(() => {
    const listener = event => {
      // Solo procesar el evento si el modal no está abierto globalmente
      if (isModalOpen) {
        return;
      }

      // Marcar el modal como abierto antes de procesarlo
      isModalOpen = true;
      isThisInstanceOpenRef.current = true;
      setTransaction(event.detail.transaction);
      setIsOpen(true);
    };

    subscribe(EVENT_NAME, listener);

    return () => {
      unsubscribe(EVENT_NAME, listener);
      // Si este componente se desmonta y tenía el modal abierto, resetear el flag
      if (isThisInstanceOpenRef.current) {
        isModalOpen = false;
        isThisInstanceOpenRef.current = false;
      }
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    isThisInstanceOpenRef.current = false;
    // Resetear el flag cuando se cierra el modal
    isModalOpen = false;
  };

  const stopPropagation = event => {
    event.stopPropagation();
    event.preventDefault();
  };

  if (!isOpen || !node) return null;

  return ReactDOM.createPortal(
    <ModalPanel tabIndex="1">
      <Content style={{ maxWidth: 500, minHeight: 200 }} onClick={stopPropagation}>
        <Bar type="success">
          <span>Tu depósito se aprobó exitosamente</span>
          <CloseButton onClick={handleClose}>
            <Iconify icon="ic:baseline-close" />
          </CloseButton>
        </Bar>
        <SuccessContent>
          <SuccessIcon>
            <Iconify icon="material-symbols:success-outline-rounded" size={48} />
          </SuccessIcon>
          <SuccessMessage>Tu balance actual es de:</SuccessMessage>
          <BalanceMessage>
            <img src={billete} className="pool-icons" />
            <span>${numeral(transaction.balance / 100).format('0,000.00')} MXN</span>
          </BalanceMessage>
          {transaction?.trans_id && (
            <TransactionIdMessage>
              <strong>Número de transacción:</strong> {transaction.trans_id}
            </TransactionIdMessage>
          )}
        </SuccessContent>
      </Content>
    </ModalPanel>,
    node
  );
};

const SuccessContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem 1.5rem;
  gap: 1rem;
  min-height: 150px;
`;

const SuccessIcon = styled.div`
  color: #78bc28;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 3rem;
`;

const SuccessMessage = styled.p`
  color: #ffffff;
  font-size: 1.3rem;
  text-align: center;
  margin: 0;
  line-height: 1.5;
`;

const BalanceMessage = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #78bc28;
  font-size: 1.7rem;
`;

const TransactionIdMessage = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  color: #656565;
  margin-top: 2em;
`;